import { render, staticRenderFns } from "./shopsAccount.vue?vue&type=template&id=fec0f184&scoped=true"
import script from "./shopsAccount.vue?vue&type=script&lang=js"
export * from "./shopsAccount.vue?vue&type=script&lang=js"
import style0 from "./shopsAccount.vue?vue&type=style&index=0&id=fec0f184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec0f184",
  null
  
)

export default component.exports